<app-header></app-header>
<div class="hero-section section pt-0">
    <div class="container pt-5">
    <div class="container h-100 text-white">
        <p class="display-6 fw-bold text-center an-1" style="padding-top: 9em;" >Get In Touch With Us</p>
      </div>
    </div>
   
  </div>


  
<div class="blog-section section container">
    <div class="row">
        <div class="col-sm-8 offset-lg-2">
            <h4 >Contact Us</h4>
            <div class="row"> 
              <div class="col-md-6">
                  <div class="row">
                      <div class="col-sm-12">
                          <mat-form-field appearance="outline">
                              <mat-label>Name</mat-label>
                              <input matInput placeholder="Name">
                          </mat-form-field>
                      </div>
                      <div class="col-sm-6">
                          <mat-form-field appearance="outline">
                              <mat-label>Country Code</mat-label>
                              <input matInput placeholder="Contry Code">
                          </mat-form-field>
                      </div>
                      <div class="col-sm-6">
                          <mat-form-field appearance="outline">
                              <mat-label>Phone </mat-label>
                              <input matInput placeholder="Phone">
                          </mat-form-field>
                      </div>
                      <div class="col-sm-12">
                          <mat-form-field appearance="outline">
                              <mat-label>Email</mat-label>
                              <input matInput placeholder="Email">
                          </mat-form-field>
                      </div>
                      <div class="col-sm-12">
                          <mat-form-field appearance="outline">
                              <mat-label>Subject</mat-label>
                              <input matInput placeholder="Subject">
                          </mat-form-field>
                      </div>
      
                      <div class="col-sm-12">
                          <mat-form-field appearance="outline">
                              <mat-label>Message</mat-label>
                              <textarea matInput placeholder="Message"></textarea>
                          </mat-form-field>
                      </div>
                      <div class="col-sm-12">
                          <button class="btn btn-success"> Send Message</button>
                      </div>
      
                  </div>
              </div>
      
              <div class="col-sm-6">
                <h4>Head Office</h4>
                <div class="row">
                    <div class="col-sm-12">
                        <ul style="list-style: none;">
                            <li>Ambassa Coach</li>
                            <li>Email Us :ambasabus2018@gmail.com</li>
                            <li>Nairobi :+254707113599/+254797340201</li>
                            <li>Garissa:0112100273</li>
                            <li>Wajir+254707113699</li>
                            <li>Elwak:+254714670668</li>
                            <li>Rhamu:+254798699654</li>
                            <li>Mandera:+254799620359</li>
                        </ul>
                      
                    </div>
                </div>
              </div>
            </div>
        </div>
    </div>
   
    
  </div>
  <app-footer></app-footer>